import {
  Button,
  Box,
  Text,
  Stack,
  Spinner,
  Center,
  HStack,
} from '@chakra-ui/react';
import { CustomCsvDownloadIcon } from '../../../theme/icons/CustomCsvDownloadIcon';
import { useEmailBatchReport } from '../../../hooks/useEmailBatchReport';

const MessageBatchResultDownload = (props) => {
  const batchId = props.batchId;
  const { emailReport, emailingBatchId } = useEmailBatchReport();
  const isDownloading = emailingBatchId !== null && emailingBatchId === batchId;

  return (
    <Stack
      spacing="18px"
      direction={{ base: 'column', sm: 'row' }}
      shouldWrapChildren="true"
      position="relative"
    >
      <Button
        size="sm"
        width={{ base: 'full', sm: '198px' }}
        onClick={() => {
          emailReport(batchId);
        }}
        isLoading={isDownloading}
      >
        {isDownloading ? (
          <Center as="span" zIndex={1}>
            <Spinner
              width="15px"
              height="15px"
              thickness="2px"
              speed="0.65s"
              emptyColor="quinaryBackground"
              mx="auto"
            />
          </Center>
        ) : (
          <Box as="span" zIndex={1}>
            <HStack alignItems="center" justifyContent="center">
              <CustomCsvDownloadIcon boxSize="20px" />
              <Text>Email CSV Report</Text>
            </HStack>
          </Box>
        )}
      </Button>
    </Stack>
  );
};

export default MessageBatchResultDownload;
